import { ADD_PATH, DETAIL_PATH, EDIT_PATH, EMPTY_PATH, LIST_PATH, MAP_PATH, SPHERE_PATH } from "../../../../crossconcern/utilities/properties/path.property";
import { NurseryListComponent } from "./list";
import { NurseryDetailComponent } from "./detail";
import { NurseryEditComponent } from "./edit";
import { NurseryNewComponent } from "./new";
import { PRIVATE_NURSERY_ADD_ROUTE, PRIVATE_NURSERY_DETAIL_ROUTE, PRIVATE_NURSERY_EDIT_ROUTE, PRIVATE_NURSERY_LIST_ROUTE, PRIVATE_NURSERY_MAP_ROUTE, PRIVATE_NURSERY_SPHERE_ROUTE } from "../../../../crossconcern/utilities/properties/routename.property";
import { SphereEditComponent } from "./sphereedit/sphereedit.component";
import { NurseryMapComponent } from "./map/nurserymap.component";
import { BackofficeGuardHelper } from "../../../../crossconcern/helpers/generic/backofficeguard.helper";
var ɵ0 = { routeName: PRIVATE_NURSERY_LIST_ROUTE }, ɵ1 = { routeName: PRIVATE_NURSERY_DETAIL_ROUTE }, ɵ2 = { routeName: PRIVATE_NURSERY_EDIT_ROUTE }, ɵ3 = { routeName: PRIVATE_NURSERY_SPHERE_ROUTE }, ɵ4 = { routeName: PRIVATE_NURSERY_MAP_ROUTE }, ɵ5 = { routeName: PRIVATE_NURSERY_ADD_ROUTE };
export var NURSERY_ROUTES = [
    {
        path: EMPTY_PATH,
        redirectTo: LIST_PATH,
        pathMatch: "full"
    },
    {
        path: LIST_PATH,
        component: NurseryListComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ0
    },
    {
        path: DETAIL_PATH + "/:id",
        component: NurseryDetailComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ1
    },
    {
        path: EDIT_PATH + "/:id",
        component: NurseryEditComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ2
    },
    {
        path: SPHERE_PATH + "/:id",
        component: SphereEditComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ3
    },
    {
        path: MAP_PATH + "/:id",
        component: NurseryMapComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ4
    },
    {
        path: ADD_PATH,
        component: NurseryNewComponent,
        canActivate: [
            BackofficeGuardHelper
        ],
        data: ɵ5
    }
];
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5 };
